import GridLayout from './grid-layout';

export default GridLayout;



// WEBPACK FOOTER //
// ./src/universal/components/grid-layout/index.js